export function isShareApiSupported() {
  return typeof navigator.share === 'function';
}
